import { ref } from 'vue'
import { createDiscreteApi } from 'naive-ui'
import { useRouter } from 'vue-router'

export function useUpgradeToProModal() {
  const showModal = ref(false)
  const router = useRouter()
  const { message } = createDiscreteApi(['message'])

  const showUpgradeToProModal = () => {
    showModal.value = true
  }

  const hideUpgradeToProModal = () => {
    showModal.value = false
  }

  const handleUpgrade = () => {
    // Navigate to upgrade page or show upgrade modal
    message.info('Chuyển hướng đến trang nâng cấp Pro...')

    // Example: Navigate to upgrade page
    // router.push({ name: 'Upgrade' })

    // Or show upgrade modal
    // showUpgradeModal()
  }

  return {
    showModal,
    showUpgradeToProModal,
    hideUpgradeToProModal,
    handleUpgrade,
  }
}
